import React from 'react'

const DialogSuccessMatchList = ({ data = {}, onDelete = () => {} }) => {
    return (
        <div className="track-body-box channel-apk-list">
            <div className="box-item box-item-title">
                <div className="track-body-title-bold">渠道包名称</div>
                <div className="track-body-title-bold">操作</div>
            </div>
            {Object.keys(data).map((channelName, index) => (
                <div className="box-item" key={index}>
                    <div className="item-left">
                        <div>{channelName}</div>
                        <div className="url ellipsis">
                            {data[channelName].type === 'url' && data[channelName].value
                                ? data[channelName].value
                                : null}
                        </div>
                    </div>
                    <div className="item-right spaui-tr-expand-cursor-pointer" onClick={() => onDelete(channelName)}>
                        删除
                    </div>
                </div>
            ))}
        </div>
    )
}

export default DialogSuccessMatchList
